import useField, { useFieldProps } from "./useField";

const useDate = <T>(props: useFieldProps<T>) => {
  const field = useField(props);
  return {
    ...field,
    fieldType: 'date',
  };
};

export default useDate;
